import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { AiOutlineCloudUpload } from "react-icons/ai";
import { API_Link, API_SRC, validateHeader } from "../commons/Constants";
import { saveAs } from "file-saver";
import {
  FaEye,
  FaRegFileAlt,
  FaStickyNote,
  FaTimes,
  FaExclamationTriangle,
} from "react-icons/fa";
import "./../assets/sass/style.css";
import "./../assets/sass/totalreview.css";
import { Modal, Tab, Tabs, Button, ProgressBar, Form } from "react-bootstrap";
import paperclip from "./../assets/img/icon/paperclip.svg";
import { BiTrash, BiErrorCircle } from "react-icons/bi";
import gif from "./../assets/img/spin.gif";
import { useSnackbar } from "notistack";
import NoteComponent from "./noteComponent";
import Select from "react-select";
import parse from "html-react-parser";

const IncludedComponent = () => {
  const MD5hash = validateHeader();
  const [arrayData, setArrayData] = useState([]);
  const [getPermission, setGetPermission] = useState([]);
  const user = JSON.parse(localStorage.getItem("user"));
  const studyLocalId = JSON.parse(localStorage.getItem("studyId"));
  const token = user?.token;
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [progress, setProgress] = useState(0);
  const [isError, setIsError] = useState(false);
  const [notes, setNotes] = useState({});
  const [isSavingNote, setIsSavingNote] = useState(false);
  const [savedNotes, setSavedNotes] = useState({});
  const [showDropdown, setShowDropdown] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filteredArticles, setFilteredArticles] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [currentOptions, setCurrentOptions] = useState([]);
  const [filterType, setFilterType] = useState("");
  const [isActive, setIsActive] = useState(null);
  const [getFileName, setgetFileName] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [dataSetUrl, setDataSetUrl] = useState("");
  const [progress1, setProgress1] = useState(0);
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [show, setShow] = useState(false);
  const [tabKey, initTabKey] = useState("one");
  const [article, setArticle] = useState([]);
  const [articleId, setArticleId] = useState([]);
  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const [error, setError] = useState("");
  const [normalizedValues, setNormalizedValues] = useState([]); // State for normalized values
  const formatOvidTags = (text) => {
    if (!text) return "";

    const formattedText = text
      .replace(/<ovid:b>(.*?)<\/ovid:b>/g, "<br><b>$1</b>")
      .replace(/<ovid:i>(.*?)<\/ovid:i>/g, "<i>$1</i>")
      .replace(/<ovid:sub>(.*?)<\/ovid:sub>/g, "<sub>$1</sub>")
      .replace(/<ovid:sup>(.*?)<\/ovid:sup>/g, "<sup>$1</sup>")
      .replace(/<ovid:u>(.*?)<\/ovid:u>/g, "<u>$1</u>")
      .replace(/<ovid:br\/>/g, "<br>")
      .replace(
        /<ovid:link href="(.*?)">(.*?)<\/ovid:link>/g,
        "<a href='$1'>$2</a>"
      )
      .replace(/<ovid:hl>(.*?)<\/ovid:hl>/g, "<mark>$1</mark>")
      .replace(/<ovid:para>(.*?)<\/ovid:para>/g, "<p>$1</p>")
      .replace(/<ovid:strike>(.*?)<\/ovid:strike>/g, "<s>$1</s>");
    return formattedText.replace(
      /^(<.*?>)*(\w)/,
      (match, tags, firstLetter) => `${tags || ""}${firstLetter.toUpperCase()}`
    );
  };
  const [isFetchingArticlesAPICalled, setIsFetchingArticlesAPICalled] =
    useState(false);
  const dropdownRef = useRef(null);
  useEffect(() => {
    const filtered = arrayData.filter(filterArticles(selectedOptions));
    setFilteredArticles(filtered);
  }, [arrayData]);
  const toggleFilterModal = () => {
    const filtered = arrayData.filter(filterArticles(selectedOptions));
    setFilteredArticles(filtered);
    setShowFilterModal(!showFilterModal);
  };

  const selectOptions = currentOptions?.map((option) => ({
    value: option,
    label: option,
  }));
  const toggleCloseModal = () => {
    setSelectedOptions([]);
    setCurrentOptions([]);
    setNormalizedValues([]);
    setFilterType("");
    setFilteredArticles(arrayData);
  };
  const toggleHideModal = () => {
    setShowFilterModal(!showFilterModal);
  };

  const authors = [
    ...new Set(
      arrayData?.map((article) => article?.authors?.split(",")[0]?.trim())
    ),
  ];
  const journals = [...new Set(arrayData?.map((article) => article?.journal))];

  const hideRemoveModal = () => {
    setShowRemove(false);
  };

  // Sort articles based on selected field
  const sortArticles = (field) => {
    const sorted = [...filteredArticles].sort((a, b) => {
      const valueA = a[field] ? a[field].toString().toLowerCase() : "";
      const valueB = b[field] ? b[field].toString().toLowerCase() : "";
      return valueA.localeCompare(valueB);
    });
    setFilteredArticles(sorted); // Call the parent callback with sorted array
    setShowDropdown(false); // Hide dropdown after selection
  };
  const handleFilterChange = (type) => {
    setFilterType(type);

    // Assuming `selectedOptions` is the array of selected options (e.g., selected years, authors, or journals)
    const normalizedValues = selectedOptions?.map((value) =>
      typeof value === "object" && value !== null && "value" in value
        ? typeof value.value === "string"
          ? value.value.toLowerCase()
          : String(value.value).toLowerCase()
        : typeof value === "string"
        ? value.toLowerCase()
        : String(value).toLowerCase()
    );

    switch (type) {
      case "year":
        const filteredYears =
          normalizedValues.length === 0
            ? [...new Set(arrayData?.map((article) => article.year))] // Show all unique years if no filters are applied
            : arrayData
                .filter((article) =>
                  normalizedValues.some(
                    (value) =>
                      article.authors
                        ?.split(",")
                        ?.map((a) => a.trim().toLowerCase())
                        .includes(value) ||
                      article.journal.toLowerCase().includes(value)
                  )
                )
                ?.map((article) => article.year)
                .filter((year, index, self) => self.indexOf(year) === index); // Remove duplicates

        // Sort the years in ascending order
        const sortedYears = filteredYears.sort((a, b) => b - a);

        setCurrentOptions(sortedYears);
        break;

      case "author":
        const filteredAuthors =
          normalizedValues.length === 0
            ? authors // Show all authors if no filters are applied
            : authors.filter((author) =>
                arrayData.some(
                  (article) =>
                    article.authors
                      ?.split(",")
                      ?.map((a) => a.trim().toLowerCase())
                      .includes(author.toLowerCase()) &&
                    normalizedValues.some(
                      (value) =>
                        String(article.year).toLowerCase().includes(value) ||
                        article.journal.toLowerCase().includes(value)
                    )
                )
              );

        // Capitalize first letter of each word in the filtered authors
        const capitalizedAuthors = filteredAuthors?.map((author) =>
          capitalizeWords(author)
        );
        setCurrentOptions(capitalizedAuthors);
        break;

      case "journal":
        const filteredJournals =
          normalizedValues.length === 0
            ? journals // Show all journals if no filters are applied
            : journals.filter((journal) =>
                arrayData.some(
                  (article) =>
                    article.journal.toLowerCase() === journal.toLowerCase() &&
                    normalizedValues.some(
                      (value) =>
                        article.authors
                          ?.split(",")
                          ?.map((a) => a.trim().toLowerCase())
                          .includes(value) ||
                        String(article.year).toLowerCase().includes(value)
                    )
                )
              );

        // Capitalize first letter of each word in the filtered journals
        const capitalizedJournals = filteredJournals?.map((journal) =>
          capitalizeWords(journal)
        );
        setCurrentOptions(capitalizedJournals);
        break;

      default:
        setCurrentOptions([]);
        break;
    }
  };

  const handleSelectChange = (options) => {
    setSelectedOptions(options || []);
  };
  const filterArticles = (selectedValues) => (article) => {
    // If no filters are selected, include all articles
    if (!selectedValues.length) {
      setNormalizedValues([]);
      return true;
    }

    // Normalize selected values (convert to lowercase)
    const normalizedValues = selectedValues?.map((value) =>
      typeof value.value === "string"
        ? value.value.toLowerCase()
        : String(value.value).toLowerCase()
    );

    // Update normalized values in the state
    setNormalizedValues(normalizedValues);

    // Check if all selected values match (AND logic)
    const matchesAllFilters = normalizedValues.every((value) => {
      // Match year
      const yearMatch = String(article?.year)?.toLowerCase().includes(value);

      // Extract the first author
      let firstAuthor;
      if (article?.authors?.includes(",")) {
        firstAuthor = article?.authors?.split(",")[0].trim();
      } else if (article?.authors?.includes(" ")) {
        firstAuthor = article?.authors?.split(" ")[0].trim();
      } else {
        firstAuthor = article?.authors?.trim();
      }
      firstAuthor = firstAuthor?.toLowerCase();
      const authorMatch = firstAuthor?.includes(value);

      // Match journal
      const journalMatch = article?.journal?.toLowerCase().includes(value);

      // Ensure the article matches all filters (year, author, journal)
      return yearMatch || authorMatch || journalMatch;
    });

    // Return true if all selected filters match the article
    return matchesAllFilters;
  };

  const highlightText = (text) => {
    if (!normalizedValues || typeof text !== "string") return text; // Ensure text is a string
    const highlighted = normalizedValues?.find((value) =>
      text?.toLowerCase().includes(value)
    );
    if (!highlighted) return text;

    const parts = text.split(new RegExp(`(${highlighted})`, "gi"));
    return parts?.map((part, index) =>
      part?.toLowerCase() === highlighted ? (
        <span
          key={index}
          style={{ backgroundColor: "yellow", fontWeight: "bold" }}
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  function capitalizeWords(str) {
    if (!str || typeof str !== "string") {
      return "Unknown Author"; // or any default text you'd like to show
    }

    return str
      .split(" ")
      ?.map(
        (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join(" ");
  }
  const getPermissionCall = () => {
    var config = {
      method: "get",
      url: `${API_Link}getAllowedStages?review_id=${localStorage.getItem(
        "studyId"
      )}`,
      headers: {
        "misr-auth": MD5hash,
        Authorization: `Bearer ${token}`,
      },
    };
    axios(config)
      .then(function (response) {
        setGetPermission(response.data.permissions[0]);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getReviewArticles = async () => {
    setIsLoading(true);
    setProgress(0); // Initialize progress to 0
    let page = 1;
    const perPage = 100; // Number of articles per page
    let totalPages = 1;
    let allResults = [];

    try {
      do {
        const config = {
          method: "get",
          url: `${API_Link}getReviewArticles`,
          params: {
            review_id: studyLocalId,
            included: "Yes",
            exclusion: "No",
            page: page,
            per_page: perPage,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
            "misr-auth": MD5hash,
          },
        };

        const response = await axios(config);
        const resData = response?.data;

        // Append new results
        allResults = [...allResults, ...resData?.articles?.data];

        totalPages = resData?.articles?.last_page; // Update totalPages for pagination
        page++;

        // Update progress as the pages are fetched
        const progressPercent = Math.min((page / totalPages) * 100, 100);
        setProgress(progressPercent);
        // Filter and sort articles after all data has been fetched
        const filteredArticles = allResults?.filter(
          (article) => article.current_stage >= 3
        );

        const sortedOptions = filteredArticles.sort(function (a, b) {
          if (a.file_path && !b.file_path) {
            return -1;
          } else if (!a.file_path && b.file_path) {
            return 1;
          } else {
            return 0;
          }
        });

        const notesTemp = filteredArticles.reduce((acc, article) => {
          acc[article.id] = article.abstract_screening_note;
          return acc;
        }, {});

        setNotes(notesTemp);
        const notesSaveTemp = filteredArticles.reduce((acc, article) => {
          if (article.abstract_screening_note !== null) {
            acc[article.id] = true;
          }

          return acc;
        }, {});
        setSavedNotes(notesSaveTemp);
        setArrayData(sortedOptions);
      } while (page <= totalPages);

      setProgress(100);
    } catch (error) {
      console.log(error);
      setIsError(true);
      // Handle loading state in case of error
    } finally {
      setIsLoading(false);
      setIsFetchingArticlesAPICalled(true);
    }
  };

  useEffect(() => {
    getPermissionCall();
    getReviewArticles();
  }, []);

  const handleCancelFile = () => {
    setSelectedFile([]);
    setgetFileName("");
    setIsFileUploaded(false);
  };
  const [isGreen, setIsGreen] = useState(
    new Array(arrayData.length).fill(false)
  );

  const handleClose = () => {
    setShow(false);
    setSelectedFile([]);
    setgetFileName("");
    setIsFileUploaded(false);
    setDataSetUrl("");
  };
  const navigate = useNavigate();
  //handle increase Decrease Height
  const handleClick = (index) => {
    setIsActive(!isActive);
    if (isActive === index) {
      return setIsActive(null);
    }
    setIsActive(index);
  };
  // handle Cahnge
  const handleChange = (e) => {
    setDataSetUrl(e.target.value);
    setSelectedFile([]);
    setgetFileName("");
    setError(""); // Clear error message when typing
  };

  const handleFileUpload = (index, id) => {
    setShow(true);

    arrayData.find((article) => {
      if (article.id === id) {
        setArticle([article]);
        setArticleId(article.id);
        setDataSetUrl(article.source);
      } else {
      }
    });
  };

  const handleFileRemoved = (index, id) => {
    setShowRemove(true);
    arrayData.find((article) => {
      if (article.id === id) {
        setArticle([article]);
        setArticleId(article.id);
      } else {
        // return article;
      }
    });
  };

  const handleFileSelect = (event) => {
    const selectedFile = event.target.files[0];
    const fileSizeInBytes = selectedFile.size;
    const fileSizeInMB = fileSizeInBytes / (1024 * 1024); // convert bytes to MB

    if (fileSizeInMB > 3) {
      console.error("File size exceeds the limit of 3 MB");
      return alert("File size exceeds the limit of 3 MB");
    } else {
      setShowProgressBar(true);
      setProgress1(0);
      const interval = setInterval(() => {
        setProgress1((prev) => {
          if (prev >= 100) {
            clearInterval(interval);
            setIsFileUploaded(true); // File is considered uploaded after 2 seconds
            setShowProgressBar(false); // Hide progress bar after upload
          }
          return prev + 25;
        });
      }, 500);
      setDataSetUrl("");
      setSelectedFile(event.target.files[0]);
      setgetFileName(event.target.files[0].name);
    }
  };
  // Handle File Upload
  const [isFileSubmitting, setIsFileSubmitting] = useState(false);
  const handleSubmit = async (event, index) => {
    event.preventDefault();
    setIsFileSubmitting(true);

    var formData = new FormData();
    formData.append("review_id", localStorage.getItem("studyId") || 1);
    formData.append("file", selectedFile);
    formData.append("id", articleId);

    await axios
      .post(`${API_Link}uploadFulltextData`, formData, {
        headers: {
          "misr-auth": MD5hash,
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.status !== 200) {
          throw new Error("Response status is not 200");
        } else if (res.data.status === 1) {
          getReviewArticles();
          enqueueSnackbar("File Uploaded Successfully", {
            variant: "success",
            autoHideDuration: 2000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
        } else {
        }
      })
      .catch((error) => {
        console.error(error.message);
        setIsFileSubmitting(false);
        enqueueSnackbar("Failed to Uplaod File", {
          variant: "error",
          autoHideDuration: 2000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      })
      .finally(() => {
        setShow(false);
        setIsFileSubmitting(false);
        setSelectedFile([]);
        setgetFileName("");
        setIsFileUploaded(false);
      });
  };

  const countFilesNotAdded = (type = null) => {
    const countTypes = arrayData.filter(
      (article) => article.file_path === type && article.source === type
    );
    return countTypes.length;
  };
  const countFilesAdded = (type = null) => {
    const countTypes = arrayData.filter(
      (article) => article.file_path !== type || article.source !== type
    );
    return countTypes.length;
  };

  const isValidURL = (url) => {
    const pattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])?)\\.)+([a-z]{2,}|[a-z\\d-]{2,})|" + // domain name
        "localhost|" + // localhost
        "\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}|" + // IPv4
        "\\[?[a-fA-F\\d]*:[a-fA-F\\d:]+\\]?)" + // IPv6
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$",
      "i"
    ); // fragment locator
    return !!pattern.test(url);
  };

  const handleUrlSubmit = async (e) => {
    e.preventDefault();
    if (isValidURL(dataSetUrl)) {
      // Reset error if the URL is valid
      setError("");

      // Your form submission logic
      const formData = new FormData();
      formData.append("review_id", localStorage.getItem("studyId") || 1);
      formData.append("source", dataSetUrl);
      formData.append("id", articleId);

      await axios
        .post(`${API_Link}uploadFulltextData`, formData, {
          headers: {
            "misr-auth": MD5hash,
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {})
        .finally(() => setShow(false));
      window.location.reload(false);
    } else {
      // Set error message if URL is invalid
      setError("Please enter a valid URL.");
    }
  };

  // Extension

  // Handle Move To Full Text
  const handleMoveToFullText = () => {
    navigate("/screeningFullText");
  };

  // delete modal code starts here
  const [showDelete, setShowDelete] = useState(false);
  const [showRemove, setShowRemove] = useState(false);

  const handleDeleteClose = () => {
    setShowDelete(false);
  };
  const handleDeleteArticle = () => {
    // getId
  };

  // code for capitalize
  const smallWords =
    /^(a|an|and|as|at|but|by|en|for|if|in|of|is|it|on|or|The|to|vs?\.?|via)$/i;
  function shouldBeUppercase(word, index, length) {
    if (index == 0 || index == length - 1) return true;

    return !smallWords.test(word.toLowerCase());
  }

  function convertFirstLetterToUpperCase(str) {
    //split into words
    const words = str.split(" ");

    //change the case and rejoin into a string
    return words
      .map((word, index, length) =>
        shouldBeUppercase(word, index, length)
          ? word.charAt(0).toUpperCase() + word.slice(1)
          : word.toLowerCase()
      )
      .join(" ");
  }
  const [isRemovingFile, setIsRemovingFile] = useState(false);
  const handleRemoveFile = () => {
    setIsRemovingFile(true);

    var config = {
      method: "post",
      url: `${API_Link}deleteFulltextData`,
      data: {
        review_id: studyLocalId,
        id: articleId,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };

    axios(config)
      .then(function (response) {
        if (response.data.status === 1) {
          setIsRemovingFile(false);
          enqueueSnackbar("File Removed Successfully", {
            variant: "success",
            autoHideDuration: 2000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
          setShowRemove(false);
          getReviewArticles();
        }
      })
      .catch(function (error) {
        console.log(error);
        setIsRemovingFile(false);
        enqueueSnackbar("Failed to Uplaod File", {
          variant: "error",
          autoHideDuration: 2000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      });
  };

  const [filesArticleIds, setFilesArticleIds] = useState("");
  useEffect(() => {
    const filesArticleIds = arrayData
      .filter((item) => item.file_path !== null || item.source !== null)
      ?.map((item) => item.id);
    setFilesArticleIds(filesArticleIds);
  }, [arrayData]);

  const [file, setFile] = useState();
  const [source, setSource] = useState();
  const [showFile, setShowFile] = useState();
  const handleOpenModal = (index, id) => {
    arrayData?.map((article) => {
      if (article.id === id) {
        setFile(article.file_path);
        setSource(article.source);
      }
    });
    setShowFile(true);
  };

  const handleCloseModal = () => {
    setShowFile(false);
  };

  const handleChangeNote = (e, articleId) => {
    const { value } = e.target;
    setNotes((prevNotes) => ({
      ...prevNotes,
      [articleId]: value, // Update note for the specific article
    }));
  };

  const handleSaveNote = async (articleId) => {
    const noteToSave = notes[articleId];
    setIsSavingNote(true);
    const data = {
      article_id: articleId,
      note: noteToSave,
      abstract: "Yes",
    };
    try {
      const config = {
        method: "post",
        url: `${API_Link}addNote`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
          "misr-auth": MD5hash,
        },
        data: data,
      };

      const res = await axios(config);
      if (res?.data?.note === null) {
        setSavedNotes((prevSavedNotes) => ({
          ...prevSavedNotes,
          [articleId]: false,
        }));
      } else {
        setSavedNotes((prevSavedNotes) => ({
          ...prevSavedNotes,
          [articleId]: true,
        }));
      }
    } catch (error) {
      enqueueSnackbar("An Error Occurs While Saving Note", {
        variant: "error",
        autoHideDuration: 2000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
    } finally {
      setIsSavingNote(false); // This will always run after the try or catch block
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    handleFileSelect({ target: { files: [file] } });
  };

  // click outside to remove drop down
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  function capitalizeTextProperly(text) {
    // Capitalize the first letter of the text
    text = text.charAt(0).toUpperCase() + text.slice(1);

    // Capitalize the first word after specified punctuation marks
    return text.replace(/([.?!:;]\s*)([a-z])/g, (match, punct, char) => {
      // Capitalize the character following the punctuation
      return punct + char.toUpperCase();
    });
  }

  return (
    <div className="page--content" onClick={handleClickOutside}>
      <div className="position-sticky position-sticky-top z-index-9">
        <div className="page--section">
          <div className="row">
            <div className="col-lg-8">
              <h1 className="page--heading">Abstracts Included</h1>
            </div>

            {getPermission && getPermission.includes(2) ? (
              <div className="col-lg-4 text-right">
                <span className="d-flex justify-content-end">
                  {/* {arrayData.length > 0 ? (
                  <button className="btn btn-primary" style={{ marginRight: '1%' }} onClick={handleExport}>Export RIS</button>
                ) : ''} */}

                  {/* {countFilesAdded() > 0 ? (
                    <button
                      onClick={handleMoveToFullText}
                      className="btn btn-primary"
                    >
                      Move to Full Text Screening
                    </button>
                  ) : (
                    <button className="btn btn-primary" disabled>
                      Move to Full Text Screening
                    </button>
                  )} */}

                  <button
                    onClick={handleMoveToFullText}
                    className={
                      countFilesAdded() === 0 || isLoading
                        ? "btn btn-primary cursor-not-allowed"
                        : "btn btn-primary"
                    }
                    disabled={countFilesAdded() === 0}
                  >
                    Move to Full Text Screening
                  </button>
                </span>
              </div>
            ) : (
              ""
            )}
            <div className="row  mt-3 count-colour d-flex align-items-center justify-content-center">
              <div className="col-lg-6 text-start">
                <div
                  style={{
                    position: "relative",
                    display: "inline-flex",
                    alignItems: "center",
                    marginLeft: "8px",
                  }}
                >
                  {/* <button onClick={toggleDropdown} className="sort-filter-btn">
                    Sort <BsSortAlphaDown style={{ fontSize: "20px" }} />
                  </button> */}
                  {showDropdown && (
                    <div
                      ref={dropdownRef}
                      style={{
                        position: "absolute",
                        top: "30px",
                        left: 0,
                        backgroundColor: "#ffffff",
                        boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.2)",
                        zIndex: 1,
                        padding: "8px",
                      }}
                    >
                      <div
                        className="sort-list-dropdown"
                        onClick={() => sortArticles("title")}
                        style={{ cursor: "pointer", padding: "4px 8px" }}
                      >
                        Title
                      </div>
                      <div
                        className="sort-list-dropdown"
                        onClick={() => sortArticles("journal")}
                        style={{ cursor: "pointer", padding: "4px 8px" }}
                      >
                        Journal
                      </div>
                      <div
                        className="sort-list-dropdown"
                        onClick={() => sortArticles("authors")}
                        style={{ cursor: "pointer", padding: "4px 8px" }}
                      >
                        Authors
                      </div>
                      <div
                        className="sort-list-dropdown"
                        onClick={() => sortArticles("abstract")}
                        style={{ cursor: "pointer", padding: "4px 8px" }}
                      >
                        Abstract
                      </div>
                    </div>
                  )}
                  {/* <button
                    onClick={toggleFilterModal}
                    className="sort-filter-btn"
                  >
                    Filter <FiFilter style={{ fontSize: "20px" }} />
                  </button> */}
                </div>
                <Modal show={showFilterModal} onHide={toggleHideModal}>
                  <Modal.Header closeButton>
                    <Modal.Title>Filter Options</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Form className="d-flex justify-content-around mb-2">
                        <Form.Check
                          type="radio"
                          label="Year"
                          name="filterType"
                          value="title"
                          checked={filterType === "year"}
                          onChange={() => handleFilterChange("year")}
                        />
                        <Form.Check
                          type="radio"
                          label="Author"
                          name="filterType"
                          value="author"
                          checked={filterType === "author"}
                          onChange={() => handleFilterChange("author")}
                        />
                        <Form.Check
                          type="radio"
                          label="Journal"
                          name="filterType"
                          value="journal"
                          checked={filterType === "journal"}
                          onChange={() => handleFilterChange("journal")}
                        />
                      </Form>
                      <Select
                        options={selectOptions}
                        isMulti
                        value={selectedOptions}
                        onChange={handleSelectChange}
                        closeMenuOnSelect={false}
                        placeholder="Select filter options..."
                      />
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={toggleCloseModal}>
                      Reset
                    </Button>
                    <Button
                      variant="primary"
                      onClick={() => {
                        toggleFilterModal();
                      }}
                    >
                      Apply Filter
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>
              <div className="col-lg-6 text-end">
                <span>
                  <span className="me-3 text-style">
                    Total: <strong>{arrayData.length}</strong>
                  </span>
                  <span className="me-3 text-success">
                    Full Text Available (File):{" "}
                    <strong>{countFilesAdded()}</strong>
                  </span>
                  {/* <span>
                    Full Text Not (File):{" "}
                    <strong className="text-style">{countFilesNotAdded()}</strong>
                  </span> */}
                </span>
              </div>
            </div>

            <Modal
              className="modal-lg abstract--modal file-upload-modal modal-dialog-centered vertical-align-center overflow-hidden"
              show={show}
              onHide={handleClose}
              backdrop="static"
              keyboard={false}
            >
              <Modal.Header className="pt-5">
                <h2 className="mb-2 Active--learning--heading">
                  Upload File or Add Link
                </h2>
                <button className="btn-close" onClick={handleClose}></button>
              </Modal.Header>

              <Tabs
                className="text-dark included-file-upload-tabs"
                activeKey={tabKey}
                onSelect={(e) => initTabKey(e)}
              >
                <Tab eventKey="one" title="File" className="modal--tab-buttons">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="mt-2 data-set-upload">
                        <form
                          onSubmit={handleSubmit}
                          className="form--ris-modal"
                        >
                          {/* Drag-and-Drop Area */}
                          <div className="upload-file-box">
                            {!getFileName && (
                              <div
                                className="cursor-pointer file-upload-box-secondary"
                                onClick={() =>
                                  document.getElementById("fileUpload").click()
                                }
                                onDrop={handleDrop}
                                onDragOver={handleDragOver}
                              >
                                <div className="upload-file-logo">
                                  <AiOutlineCloudUpload size={150} />
                                  <p>Drag and drop a file or click to select</p>
                                </div>
                                <input
                                  id="fileUpload"
                                  type="file"
                                  name="myFile"
                                  required
                                  style={{ display: "none" }}
                                  onChange={handleFileSelect}
                                  disabled={!!dataSetUrl}
                                />
                              </div>
                            )}
                            {/* Progress Bar Section */}
                            {showProgressBar && (
                              <div
                                className="card mt-4 p-3 position-relative"
                                style={{
                                  width: "100%",
                                  maxWidth: "120vh",
                                  margin: "0 auto",
                                  borderRadius: "20px",
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  padding: "15px",
                                }}
                              >
                                <FaRegFileAlt
                                  size={30}
                                  style={{ marginRight: "10px" }}
                                />
                                <div
                                  style={{
                                    flex: 1,
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <p
                                    style={{
                                      marginBottom: "5px",
                                      fontSize: "18px",
                                      padding: "0px 5px",
                                    }}
                                  >
                                    {selectedFile.name}
                                  </p>
                                  <ProgressBar
                                    now={progress1}
                                    variant="secondary"
                                    style={{ width: "100%" }}
                                  />
                                </div>
                              </div>
                            )}

                            {/* File Name Section */}
                            {getFileName && !showProgressBar && (
                              <div
                                className="card mt-4 p-3 position-relative"
                                style={{
                                  width: "100%",
                                  maxWidth: "120vh",
                                  margin: "0 auto",
                                  borderRadius: "20px",
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  padding: "15px",
                                }}
                              >
                                <FaTimes
                                  size={20}
                                  style={{
                                    position: "absolute",
                                    top: "20px",
                                    right: "10px",
                                    cursor: "pointer",
                                    color: "red",
                                  }}
                                  onClick={handleCancelFile}
                                />
                                <FaRegFileAlt
                                  size={30}
                                  style={{
                                    marginRight: "10px",
                                    color: "#0b63d3",
                                  }}
                                />
                                <p
                                  style={{
                                    fontSize: "18px",
                                    padding: "0px 5px",
                                  }}
                                >
                                  {selectedFile.name}
                                </p>
                              </div>
                            )}
                          </div>

                          {/* Upload Button */}
                          <button
                            type="submit"
                            // className="btn btn-lg btn-success upload-file-ris"
                            // className= {!isFileUploaded ? "btn btn-lg btn-success cursor-not-allowed" :"btn btn-lg btn-success" }
                            className={
                              !isFileUploaded
                                ? "upload-btn-disable upload-btn"
                                : "upload-btn"
                            }
                            disabled={!isFileUploaded}
                          >
                            Upload File
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                </Tab>

                <Tab eventKey="two" title="URL" className="modal--tab-buttons">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="mt-2 data-set-upload">
                        <form
                          onSubmit={handleUrlSubmit}
                          className="form--ris-modal"
                        >
                          <div className="mb-3">
                            <span className="d-flex justify-content-start mb-3">
                              <span
                                className="text-info"
                                style={{ fontSize: "22px" }}
                              >
                                Dataset URL
                              </span>
                            </span>
                            <input
                              id="fileUpload"
                              style={{ height: "60px" }}
                              type="text"
                              value={dataSetUrl}
                              name="myFile"
                              required
                              className={`form-control ${
                                error ? "is-invalid" : ""
                              }`}
                              onChange={handleChange}
                              disabled={!!getFileName}
                            />
                            {/* Added a div to separate the error and input */}
                            <div className="error-message">
                              <span id="urlError" className="text-danger">
                                {error}
                              </span>
                            </div>
                          </div>
                          <div className="button-wrapper">
                            <input
                              type="submit"
                              value="Add URL"
                              className={
                                !dataSetUrl
                                  ? "upload-btn-disable upload-btn"
                                  : "upload-btn"
                              }
                              disabled={!dataSetUrl}
                            />
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </Tab>
              </Tabs>
            </Modal>
          </div>
        </div>
        {isLoading && (
          <div className="progressBarData">
            <ProgressBar now={progress} />
          </div>
        )}
      </div>
      <div className="row">
        {filteredArticles &&
          filteredArticles?.length > 0 &&
          filteredArticles?.map(
            ({ id, title, authors, journal, abstract, doi, year }, index) => (
              <div className="row  " key={index}>
                {/* Handle Background Color Change On Include, Exclude  */}
                <div
                  className="inner--box--row"
                  // style={{
                  //   backgroundColor:
                  //     isGreen[index] || filesArticleIds.includes(id)
                  //       ? " rgba(0,255,0,0.2)"
                  //       : "",
                  // }}
                  style={{
                    backgroundColor: filesArticleIds.includes(id)
                      ? " rgba(0,255,0,0.2)"
                      : "",
                  }}
                >
                  <span className="index--numbering fw-bold">{index + 1})</span>
                  <div className="row width-100">
                    <div className="width--70">
                      <h1 className="heading3">
                        {parse(
                          formatOvidTags(convertFirstLetterToUpperCase(title))
                        )}
                      </h1>
                      {authors && authors !== "?" ? (
                        <div className="d-flex ">
                          <p className="small text-muted authors-font ms-1">
                            <span className="authors-font fw-bold">
                              Author(s):
                            </span>{" "}
                            {highlightText(
                              capitalizeWords(authors.replace(/,/g, ", ")) +
                                ".",
                              normalizedValues
                            )}
                          </p>
                        </div>
                      ) : (
                        ""
                      )}
                      {journal ? (
                        <label
                          className="small text-muted journal-font"
                          htmlFor="flexCheckDefault2"
                        >
                          <span className="fw-bold">Journal:</span>{" "}
                          {highlightText(
                            capitalizeWords(journal) + ".",
                            normalizedValues
                          )}
                        </label>
                      ) : (
                        ""
                      )}
                      <div>
                        {year ? (
                          <label className="small text-muted journal-font">
                            <span className="fw-bold">Year:</span>{" "}
                            {highlightText(year, normalizedValues)}
                          </label>
                        ) : (
                          ""
                        )}
                      </div>

                      <p
                        className={
                          isActive === index
                            ? "Increase-height--of--paragraph cursor-pointer"
                            : "Reduce-height--of--paragraph underline-showAbstarct"
                        }
                        onClick={() => handleClick(index)}
                      >
                        
                        {isActive === index
                          ? (parse(formatOvidTags(abstract)))
                          : "Show Abstract"}
                      </p>
                    </div>
                    <div className="width-30">
                      <div className="btn--new--ul">
                        <Link
                          to="#"
                          data-bs-toggle="tooltip"
                          className="link position-relative"
                          title="Add Note"
                          onClick={() => handleClick(index)}
                        >
                          {savedNotes[id] && <span className="dot"></span>}
                          <FaStickyNote />
                        </Link>
                        {getPermission && getPermission.includes(2) ? (
                          <span>
                            {filesArticleIds.includes(id) ? (
                              <>
                                <Link
                                  to="#"
                                  data-bs-toggle="tooltip"
                                  className="link"
                                  title="View"
                                  onClick={() => handleOpenModal(index, id)}
                                >
                                  {/* <img src={paperclip} /> */}
                                  <FaEye />
                                </Link>
                                <Link
                                  to="#"
                                  className="link bg-danger"
                                  title="Remove File"
                                  onClick={() => handleFileRemoved(index, id)}
                                >
                                  <BiTrash />
                                </Link>
                              </>
                            ) : (
                              <Link
                                to="#"
                                data-bs-toggle="tooltip"
                                className="link"
                                title="Upload or Link File"
                                onClick={() => handleFileUpload(index, id)}
                              >
                                <img src={paperclip} alt="" />
                              </Link>
                            )}

                            <br />
                            <span className="upload-link-file"></span>
                            <Modal
                              className="modal-dialog-centered "
                              show={showDelete}
                              onHide={handleDeleteClose}
                              backdrop="static"
                              keyboard={false}
                            >
                              <Modal.Header closeButton>
                                <Modal.Title>Confirm!</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                This Article is Without File Would You Like to
                                Delete it?
                              </Modal.Body>
                              <Modal.Footer>
                                <Button
                                  variant="secondary"
                                  onClick={handleDeleteClose}
                                >
                                  Cancel
                                </Button>
                                <Button
                                  variant="danger"
                                  onClick={handleDeleteArticle}
                                >
                                  Delete
                                </Button>
                              </Modal.Footer>
                            </Modal>

                            {/*  */}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    {isActive === index && (
                      <NoteComponent
                        id={id}
                        notes={notes}
                        handleChangeNote={handleChangeNote}
                        handleSaveNote={handleSaveNote}
                        isSavingNote={isSavingNote}
                        savedNotes={savedNotes}
                      />
                    )}
                  </div>
                </div>
                {showFile && (
                  <>
                    <div className="template_modal z-index-99">
                      <div className="template_modal-wrapper">
                        <div className="modal--header">
                          <div className="text-end">
                            <button
                              className="btn-danger"
                              onClick={() => {
                                handleCloseModal();
                              }}
                            >
                              Close
                            </button>
                          </div>
                        </div>
                        <div className="modal--body">
                          {source && (
                            <iframe
                              width="100%"
                              title="attached file"
                              src={`${source}`}
                            ></iframe>
                          )}
                          {file && (
                            <iframe
                              width="100%"
                              title="attached file"
                              src={`${API_SRC + "/" + file}`}
                            ></iframe>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            )
          )}

        {isLoading && (
          <div
            className={
              arrayData?.length >= 100 ? "loading-second-time" : "preload"
            }
          >
            <img src={gif} alt="Loading..." />
          </div>
        )}
        {isFetchingArticlesAPICalled && isError && !isLoading && (
          <div className="no-data-found-main">
            <h5 className="no-data-found text-muted m-auto opacity-50">
              <BiErrorCircle size={50} color="orange" />
              <span className="ms-3">Some thing went wrong.</span>
            </h5>
          </div>
        )}
        {isFetchingArticlesAPICalled &&
          !isLoading &&
          arrayData?.length === 0 &&
          !isError && (
            <div className="no-data-found-main">
              <h4 className="no-data-found text-muted m-auto opacity-50">
                <FaExclamationTriangle size={50} color="orange" />
                <span className="ms-3">There are no included abstract.</span>
              </h4>
            </div>
          )}
      </div>

      <Modal
        className="modal-dialog-centered "
        show={showRemove}
        onHide={hideRemoveModal}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Remove attached file !</Modal.Title>
        </Modal.Header>
        <Modal.Body>Please confirm do you want to remove file ?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={hideRemoveModal}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={handleRemoveFile}
            disabled={isRemovingFile}
          >
            {isRemovingFile ? "Deleting" : "Delete"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default IncludedComponent;
